import { Link } from 'react-router-dom';
import { EnvelopeSimple, Phone, MapPin } from '@phosphor-icons/react';

// Bundled locally (public/logo.png) so ad-blockers and strict corporate
// networks that filter `customer-assets.emergentagent.com` still render it.
const LOGO_URL = '/logo.png';

export default function Footer() {
  return (
    <footer className="bg-blue-950 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="space-y-4">
            <img src={LOGO_URL} alt="Study Alliance" className="h-16 w-auto brightness-110" />
            <p className="text-blue-200/70 text-sm leading-relaxed">
              Guiding students to the right college and career path. Expert admission support, exam preparation, and document guidance.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-blue-200 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              {[{ label: 'About Us', path: '/about' }, { label: 'Services', path: '/services' }, { label: 'Exam Preparation', path: '/exam-prep' }, { label: 'For Students', path: '/for-students' }, { label: 'Contact Us', path: '/contact' }].map(l => (
                <li key={l.path}><Link to={l.path} className="text-blue-300/70 hover:text-white text-sm transition-colors">{l.label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-blue-200 mb-4">For Partners</h4>
            <ul className="space-y-2.5">
              {[{ label: 'For Recruiters', path: '/for-recruiters' }, { label: 'Recruiter Sign Up', path: '/recruiter-signup' }, { label: 'Recruiter Guidelines', path: '/recruiter-guidelines', testid: 'footer-partners-recruiter-guidelines-link' }, { label: 'Partner Login', path: '/login' }].map(l => (
                <li key={l.path}><Link to={l.path} data-testid={l.testid} className="text-blue-300/70 hover:text-white text-sm transition-colors">{l.label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-blue-200 mb-4">Get in Touch</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5">
                <EnvelopeSimple size={18} className="text-blue-400 mt-0.5 shrink-0" />
                <span className="text-blue-300/70 text-sm">hello@studyalliance.ca</span>
              </li>
              <li className="flex items-start gap-2.5">
                <Phone size={18} className="text-blue-400 mt-0.5 shrink-0" />
                <span className="text-blue-300/70 text-sm">+1 (604) 735-9791</span>
              </li>
              <li className="flex items-start gap-2.5">
                <MapPin size={18} className="text-blue-400 mt-0.5 shrink-0" />
                <span className="text-blue-300/70 text-sm">2025 Willingdon Ave, Suite 900<br/>Burnaby, BC V5C 0J3</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-blue-900 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-blue-400/50 text-xs">&copy; {new Date().getFullYear()} Study Alliance. All rights reserved.</p>
          <div className="flex flex-wrap gap-6 justify-center">
            <span className="text-blue-400/50 hover:text-blue-300 text-xs cursor-pointer">Privacy Policy</span>
            <span className="text-blue-400/50 hover:text-blue-300 text-xs cursor-pointer">Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
